module.exports = __webpack_public_path__ + "img/ss_ye-10.3a0527d0.jpg";